import { Locales } from '@/app/locales/types.ts';

export const DEV_MODE = import.meta.env.DEV;
export const STAGING_MODE = import.meta.env.VITE_ENV_MODE === 'staging';
export const DEFAULT_LOCALE = Locales.RU;
